module.exports = __webpack_public_path__ + "img/chris_g_25.16da9751.jpg";